import React from 'react'
import styled from 'styled-components'
import Carousel from './carousel'

const Card = styled.section`
  background-color: #2424e9;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 45px 0 rgba(0, 0, 0, 0.1), 0 61px 67px 0 rgba(0, 0, 0, 0.05);
  margin: 0 15px 10px;
  padding: 40px 25px;
  position: relative;
  text-align: center;
  z-index: 2;

  @media (min-width: 768px) {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 0 auto 10px;
    padding: 64px 100px 64px;
  }
`

const Span = styled.span`
  color: #33c482;
`

const SubCard = styled(Card)`
  flex-direction: column;
  justify-content: center;
  padding: 40px 30px;
  text-align: center;
  
  @media (min-width: 768px) {
    padding: 48px 100px 54px;
  }
`

const SubCardTitle = styled.h2`
  display: block;
  line-height: 1.67;
  margin-bottom: 32px;
  width: 100%;

  @media (min-width: 768px) {
    margin-bottom: 48px;
  }
`

const WhoBelieveInUs = styled.div`
  display: inline-flex !important;
  flex-direction: column;
  height: 116px;
  justify-content: space-between;

  img,
  svg {
    display: block;
    margin: 0 auto;
  }

  p {
    font-size: 18px;
    color: #576684;
    line-height: 1.11;
    font-weight: 800;
  }

  span {
    font-size: 12px;
    font-weight: 1.67;
    padding-bottom: 24px;
  }

  @media (min-width: 768px) {
    height: 92px;
    width: 170px;
    
    img,
    p,
    svg {
      display: block;
      margin: 0 auto;
    }
  }
`

class Partners extends React.Component {
  
  render() {
    const settings = {
      dots: true,
    }

    return (<SubCard>
      <SubCardTitle>
        {this.props.partnersTitle} <Span>{this.props.beetech}</Span>
      </SubCardTitle>
      <Carousel settings={settings}>
        <WhoBelieveInUs>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="101"
            height="30"
            viewBox="0 0 101 30"
          >
            <g fill="none" fillRule="evenodd">
              <path
                fill="#576684"
                d="M70.804 18.644c-2.346 0-3.94-1.607-3.94-3.972 0-2.366 1.594-3.973 3.94-3.973 2.065 0 3.659 1.8 3.659 3.973 0 2.27-1.69 3.972-3.659 3.972zm.466-11.356c-1.594 0-3.002.566-4.13 1.42V7.571h-3.659V28.96h3.85v-8.137c1.127.854 2.345 1.324 3.849 1.324 2.065 0 4.13-.945 5.348-2.462 1.128-1.324 1.784-3.027 1.784-5.013-.095-4.165-3.192-7.384-7.042-7.384zm24.966 5.585c-.095-1.229-1.218-2.558-2.817-2.558-1.598 0-2.907 1.229-3.002 2.558h5.82zm3.569 6.717c-1.409 1.607-3.66 2.557-5.82 2.557-4.225 0-7.413-2.932-7.413-7.475 0-3.973 2.722-7.475 6.947-7.475 3.94 0 6.757 3.31 6.757 7.288 0 .379 0 .758-.095 1.137h-9.95c.186 1.986 1.785 3.406 3.85 3.406 1.594 0 2.907-.945 3.568-1.607l2.156 2.169zm-19.337 2.274h3.85V.854h-3.85v21.01zm-26.746-3.22c-2.345 0-3.94-1.607-3.94-3.972 0-2.366 1.595-3.973 3.94-3.973 2.065 0 3.66 1.8 3.66 3.973 0 2.27-1.69 3.972-3.66 3.972zm.467-11.356c-1.594 0-3.003.566-4.13 1.42V7.571h-3.755V28.96h3.85v-8.137c1.127.854 2.346 1.324 3.85 1.324 2.064 0 4.13-.945 5.347-2.462 1.128-1.324 1.785-3.027 1.785-5.013 0-4.165-3.098-7.384-6.947-7.384zM39.077 21.864h3.85V7.57h-3.85v14.293zM41.052 0a2.434 2.434 0 0 1 2.44 2.461c0 1.42-1.127 2.462-2.536 2.462-1.408 0-2.536-1.042-2.536-2.462A2.6 2.6 0 0 1 41.052 0zm-4.32 10.977c-.282-.096-.848-.187-1.41-.187-1.688 0-3.473 1.324-3.473 3.028v8.046H28V7.57h3.659v1.42c.847-1.041 2.44-1.703 4.13-1.703.561 0 .847.096 1.313.096l-.37 3.593zM14.831 2.657a5.172 5.172 0 0 0-2.536 4.448c0 .945.376 1.895.847 2.744.376.758.561 2.083-.752 2.745-.937.566-2.16.187-2.722-.758-.561-.758-1.218-1.517-2.065-2.083-1.593-.945-3.473-.945-5.067 0A5.18 5.18 0 0 0 0 14.206c0 1.799.937 3.502 2.536 4.447 1.594.945 3.474.945 5.067 0 .847-.475 1.504-1.228 1.97-2.082.376-.662 1.409-1.516 2.722-.758.937.566 1.218 1.8.752 2.744-.471.854-.752 1.8-.752 2.745 0 1.799.937 3.502 2.536 4.447 1.594.945 3.474.945 5.067 0a5.172 5.172 0 0 0 2.537-4.447c0-1.8-.938-3.503-2.537-4.448-.846-.475-1.784-.662-2.816-.662-.847 0-1.97-.566-1.97-1.986 0-1.137.847-1.987 1.97-1.987.937 0 1.97-.187 2.816-.662a5.172 5.172 0 0 0 2.537-4.447c0-1.8-.938-3.503-2.537-4.448C19.147 2.187 18.21 2 17.362 2h-.03c-.835 0-1.763.193-2.5.657"
              />
            </g>
          </svg>
          <span dangerouslySetInnerHTML={{__html: this.props.partnersFirstItem}}></span>
        </WhoBelieveInUs>
        <WhoBelieveInUs>
          <img
            alt="Logo Visa Track - Programa de aceleração da visa"
            src="/images/grey.png"
            srcSet="/images/grey@2x.png 2x,
            /images/grey@3x.png 3x"
            height="50"
            width="106"
          />
          <span dangerouslySetInnerHTML={{__html: this.props.partnersSecondItem}}></span>
        </WhoBelieveInUs>
        <WhoBelieveInUs>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="24"
            viewBox="0 0 59 24"
          >
            <g fill="#576684" fillRule="evenodd">
              <path d="M19.706 16.565c0 1.73-.017 3.46.01 5.189.008.522-.18.795-.673.928-3.714 1.003-7.477 1.542-11.28.704-3.59-.792-5.96-3.071-7.033-6.615-.955-3.15-1-6.357.024-9.49C1.79 4.111 3.996 1.976 7.117.897c4.009-1.385 8.014-1.062 11.982.255.41.135.616.342.351.842-.388.734-.683 1.518-1.02 2.28-.43.965-.406.876-1.404.592-1.304-.372-2.64-.75-3.982-.838-4.522-.295-7.53 2.639-7.833 7.318-.108 1.66.09 3.298.71 4.846 1.003 2.502 3.3 3.806 6.23 3.588.534-.04 1.064-.12 1.596-.179 1.112-.121 1.113-.12 1.115-1.272 0-.973-.04-1.948.013-2.918.04-.746-.306-.935-.955-.92-.963.023-1.927-.022-2.889.016-.527.02-.736-.165-.726-.688.016-.892.02-1.784-.002-2.676-.013-.501.207-.65.677-.648 2.681.013 5.362.016 8.043-.003.538-.003.695.213.69.722-.02 1.783-.007 3.567-.007 5.351M58.296 18.784c0 1.13.027 2.312-.026 3.49-.009.19-.341.445-.574.53-2.326.855-4.74 1.094-7.193.919-2.961-.212-5.507-1.306-7.336-3.76-1.203-1.613-1.755-3.486-2.026-5.464-.426-3.12-.208-6.168 1.268-8.983C44.536 1.461 48.116-.02 52.482.024c2.005.021 3.925.46 5.789 1.18.943.363.96.419.576 1.33-.293.694-.634 1.375-.85 2.094-.224.752-.583.791-1.251.548-1.226-.445-2.468-.992-3.741-1.126-3.449-.361-5.68 1.346-6.553 4.92-.552 2.26-.507 4.553.19 6.795.994 3.194 3.173 4.172 6.166 3.967 1.794-.123 3.564-.603 5.488-.948M24.527 11.913c0-3.567.015-7.134-.013-10.7-.005-.67.2-.887.868-.882 3.967.025 7.934.025 11.902.001.749-.004 1.088.211 1.013 1.023-.064.696-.031 1.404-.002 2.105.026.618-.198.852-.839.843-2.358-.031-4.718.011-7.076-.026-.713-.01-.938.236-.916.938a74.52 74.52 0 0 1 .001 4.215c-.019.707.251.957.94.949 2.114-.027 4.229.01 6.343-.025.68-.012.988.165.93.908-.057.752-.038 1.513-.003 2.268.029.61-.218.79-.803.783-2.144-.027-4.29.014-6.433-.024-.732-.012-.989.22-.977.974.037 2.431-.004 4.864.024 7.296.008.654-.185.922-.867.894a37.864 37.864 0 0 0-3.295.001c-.658.03-.813-.22-.808-.841.023-3.567.011-7.134.011-10.7" />
            </g>
          </svg>
          <span dangerouslySetInnerHTML={{__html: this.props.partnersThirdItem}}></span>
        </WhoBelieveInUs>
        <WhoBelieveInUs>
          <p>Marcelo Maisonnave</p>
          <span dangerouslySetInnerHTML={{__html: this.props.partnersFourthItem}}></span>
        </WhoBelieveInUs>
      </Carousel>
    </SubCard>)
  }
}

export default Partners
